var site = site || {};
var YT = YT || {};
var generic = generic || {};

(function ($) {
  site.videos = {
    open: function (opts) {
      var provider = !_.isEmpty(opts.provider) ? opts.provider : '';

      if (provider === 'youtube') {
        this.openYouTube(opts);
      }
    },
    openYouTube: function (opts) {
      var ytId = opts.youTubeId;
      var content = '<div class="js-embed-container"><div class="js-content-block-video-placeholder"></div></div>';
      var $ytContent = $('.js-play', opts.context);

      $ytContent.append(content);

      function createVideoPlayerDiv($elem, i) {
        var id = $elem.attr('class') + '-' + i;

        $elem
          .parent()
          .append('<div />')
          .children('div')
          .attr('id', id);

        return id;
      }
      function addVideo(ytId, iframeId) {
        // https://developers.google.com/youtube/player_parameters#Parameters
        new YT.Player(iframeId, {
          width: '100%',
          videoId: ytId,
          playerVars: {
            modestbranding: 1,
            controls: 1,
            showinfo: 0,
            rel: 0,
            autoplay: 1
          }
        });
      }
      // Create a new div for the player to take over inside of the colorbox
      var iframeId = createVideoPlayerDiv($('.js-content-block-video-placeholder'), Math.floor(+new Date() / 1000));

      // Instantiate the video
      addVideo(ytId, iframeId);
      var options = {
        content: $('.js-embed-container', $ytContent),
        className: 'colorbox--video',
        height: 'auto',
        width: '100%',
        maxWidth: 1024,
        maxHeight: 768
      };

      generic.overlay.launch(options);
      $.colorbox.resize();
    }
  };
  var videoBlock = {
    setup: function ($elements, context) {
      var $modules = $elements;

      $modules.each(function () {
        var $module = $(this);
        var $play = $module;
        var provider = $module.data('video-provider');
        var isYoutube = provider === 'youtube';

        $play.once().click(function (event) {
          event.preventDefault();
          var opts = {
            context: context,
            provider: provider
          };

          if (!!isYoutube) {
            opts.youTubeId = $module.data('youtube-id');
          }
          site.videos.open(opts);

          return false;
        });
      });
    }
  };

  $(document).on('youtubeIframeAPI.loaded', function () {
    var $elements = $('.js-video').filter("[data-video-provider='youtube']");

    if ($elements.length) {
      videoBlock.setup($elements, document);
    }
  });
  Drupal.behaviors.productImageV1 = {
    attach: function (context) {
      var $quickshopContent = $('.js-quickshop-container-content', context);
      var $quickshopVideo = $quickshopContent.find('video');

      if ($quickshopVideo.length === 1) {
        $quickshopContent.addClass('quickshop-container-content');
      }
    }
  };
})(jQuery);
